import { faqData } from '@/mocks/homeData';

export default function SectionFaq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-2">关于亚洲影视网免费追剧的常见疑问解答</p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-4">
          {faqData.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-5 md:p-6">
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-primary-100 text-primary-600 rounded text-sm font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mt-3 pl-9">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}